<template>
  <div>
    <h3>Envoi de codes promotionnels</h3>
    <p>L'équipe de {{host}} vous remercie de votre confiance. En signe d'appréciation, nous enverrons périodiquement des codes promotionnels aux joueurs réguliers. Profitez du jeu!</p>
  </div>
</template>
<script>
  export default {
    name: 'bonus-rules-mailing-fr',
    computed: {
      host() {
        return window.location.hostname;
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/fr.vue